















































import {Component, Prop, Watch} from "vue-property-decorator";
import AsiListTable from "@/components/common/AsiListTable.vue";
import UserListEntry from "@/models/user/UserListEntry";
import UserListFilter from "@/models/user/UserListFilter";
import IAsiListTableImplementation from "@/components/common/IAsiListTableImplementation";
import AsiListTableHeader from "@/components/common/AsiListTableHeader";
import {enumTextFromValue, enumToSelectItems} from "@/helpers/functions_asi";
import {CompanyType, EmploymentType, Gender, Permissions, UserState} from "@/helpers/constants";
import AsiListTableLayout from "@/components/common/AsiListTableLayout.vue";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import AsiAvatar from "@/components/common/AsiAvatar.vue";
import {Icon} from "@/helpers/icons";
import AsiTextFieldSimple from "@/components/common/AsiTextFieldSimple";
import AsiSelectSimple from "@/components/common/AsiSelectSimple";
import PaginatedResponse from "@/models/PaginatedResponse";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import {getCompanyIcon} from "@/helpers/functions_td";
import UserSimple from "@/models/user/UserSimple";
import Company from "@/models/company/Company";

@Component({
	components: {AsiSelectSimple, AsiTextFieldSimple, AsiAvatar, AsiContentContainer, AsiListTableLayout}
})
export default class UserList extends AsiListTable<UserListEntry, UserListFilter> implements IAsiListTableImplementation<UserListEntry, UserListFilter> {

	@Prop({type: Object, default: null})
	public company!: Company | null;

	@Prop({type: Boolean, default: false})
	public hideToolbar!: boolean;

	private icons = Icon;
	private genderOptions = enumToSelectItems(Gender, true);
	private employmentTypeOptions = enumToSelectItems(EmploymentType, true);
	private userStateOptions = enumToSelectItems(UserState, true);
	private companyTypeOptions = enumToSelectItems(CompanyType, true);

	public constructor() {
		super();
		this.filterModel = this.createFilterModel();
	}

	public mounted(): void {
		this.tableOptions.sortBy = ['firstname', 'lastname'];
		this.tableOptions.sortDesc = [false, false];
	}

	private get isInternal(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightInternal);
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	public createFilterModel(): UserListFilter {
		return new UserListFilter();
	}

	public createHeaders(): AsiListTableHeader[] {
		const columns = [
			new AsiListTableHeader('', 'avatar', false, false, 'center', '4rem'),
			new AsiListTableHeader(this.$t('user.firstname').toString(), 'firstname', true, true, 'start', this.company === null ? '20%' : '30%'),
			new AsiListTableHeader(this.$t('user.lastname').toString(), 'lastname', true, true, 'start', this.company === null ? '20%' : '30%'),
			new AsiListTableHeader(this.$t('user.username').toString(), 'username', true, true, 'start', this.company === null ? '20%' : null),
		];
		if (this.company === null) {
			columns.push(new AsiListTableHeader(this.$t('company.singular').toString(), 'company', false, true, 'start'));
		}
		return columns;
	}

	public fetchData(filterModel: UserListFilter | null, tableOptions: AsiListTableOptions | null): Promise<PaginatedResponse<UserListEntry>> {
		if (this.company !== null) {
			return this.$companyService.users(this.company.id, filterModel, tableOptions);
		}

		return this.$userService.users(filterModel, tableOptions);
	}

	public filterTextChanged(filterText: string): void {
		if (this.filterModel === null) return;
		this.filterModel.fulltext = filterText;
	}

	public openModelDetailPage(model: UserListEntry): void {
		this.$router.push({name: 'User', params: {id: model.id}})
	}

	public reload(goToFirstPage: boolean = false): void {
		this.reloadInternal(this, goToFirstPage);
	}

	protected companyTypeIcon(type: CompanyType): string {
		return getCompanyIcon(type);
	}

	protected companyTypeLabel(type: CompanyType): string | null {
		return enumTextFromValue(CompanyType, type, true);
	}

	protected avatarUrl(userSimple: UserSimple): string | null {
		return UserSimple.avatarUrlMedium(userSimple);
	}

	private fullName(user: UserListEntry): string | null {
		return UserListEntry.fullName(user);
	}

	@Watch('tableOptions', {deep: true})
	private onTableOptionsChanged(): void {
		this.reload();
	}

	@Watch('filterModel', {deep: true})
	private onFilterModelChanged(): void {
		this.reload(true);
	}

}
